import {
    VisualizationAdapterV2,
    VisualizationEntity,
} from '../../../app/visualization-v2';
import { VisualizationPayload } from '../../../api';
import { VisualizationImplConfigV2 } from './visualizationImplConfig';

export function createVisualizationImplV2(
    config: VisualizationImplConfigV2
): VisualizationAdapterV2 {
    const {
        api: { visualization: api },
    } = config;

    function toEntity(dto: VisualizationPayload): VisualizationEntity {
        return dto;
    }

    return {
        async create(context, props) {
            const response = await api.visualization.create(context, props);
            return toEntity(response);
        },
    };
}
